'use strict';

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _mainRoute = require('./main.route');

var _mainRoute2 = _interopRequireDefault(_mainRoute);

angular.module('BTMS').config(_mainRoute2['default']);

require('./home');
require('./choose-seat');
require('./buy-ticket');
require('./payment-ready');
require('./about-us');
require('./contacts');
require('./offices');
require('./how-to');
require('./rent');
require('./recomendations');
require('./terms-and-conditions');
require('./terms');
require('./privacy');
require('./cookie-policy');


/** WEBPACK FOOTER **
 ** ./client/public/main/index.js
 **/